import { Stack } from '@mui/material'
import { useAction } from '../../containers/facilityLotteryReservationDetail/facilityLotteryReservationDetailService'
import { translate } from '../../i18n'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { GContainer, GItem } from '../components/common/grids'
import { InfoCard } from '../components/common/infoCard'
import LotteryReservationDetailGItems from '../components/common/lotteryReservationDetail/lotteryReservationDetailGItems'

export const FacilityLotteryReservationDetail = () => {
  const {
    lotteryReservationDetail,
    showSiblingsLotteryResultReferenceFlag,
    goCancel,
    goChange
  } = useAction()

  if (lotteryReservationDetail == null) {
    return null
  }

  return (
    <Stack spacing={2}>
      <GContainer rowSpacing={2}>
        <GItem md={3}></GItem>
        <GItem xs={12} md={6}>
          <Stack spacing={1}>
            <InfoCard>
              <GContainer>
                <LotteryReservationDetailGItems
                  lotteryReservation={lotteryReservationDetail}
                  useReason={lotteryReservationDetail.useReason}
                  displayType="reference"
                  showSiblingsLotteryResultReferenceFlag={showSiblingsLotteryResultReferenceFlag}
                />
              </GContainer>
            </InfoCard>
          </Stack>
        </GItem>
        <GItem md={3}></GItem>
      </GContainer>
      <BottomButtonGroup>
        {
          lotteryReservationDetail.canCancel && (
            <ButtonOutlinedWarningL fullWidth onClick={() => goCancel()}>
              {translate('facilityLotteryReservationDetail.button.cancel')}
            </ButtonOutlinedWarningL>
          )
        }
        {
          lotteryReservationDetail.canUpdate && (
            <ButtonL fullWidth onClick={goChange}>
              {translate('system.button.change')}
            </ButtonL>
          )
        }
        <BackButton />
      </BottomButtonGroup>
    </Stack>
  )
}
